import React, { useState } from 'react'
import { StateZipForm } from '../../../../shared/components/Forms/StateZipForm'
import Location from '../../../../../../assets/images/applicants/landing_page/location.svg'
import { HeroTypes } from './types'
import { AppIcons } from '../../../../shared/components/Forms/DownloadAppForm'


export const Hero = ({ locale, country, currentState, nearmeFormAction, title, subtitle, alt, countryPlaceholders, content }: HeroTypes) => {
  return (
    <div className="jobs-hero lg:max-w-7xl px-7 xl:px-0 py-10 lg:pb-24 lg:pt-0 m-auto text-kale text-base lg:text-xl flex flex-col lg:flex-row items-center justify-between">
      <div>
        <span className="flex"><img src={Location} alt="green location marker" className="mr-2.5" />{currentState.display_name}</span>
        <h1 className="text-mxl lg:text-7xl font-medium font-heading mt-4 lg:mt-9 mb-5 lg:mb-9 lg:max-w-2xl lg:pr-8">{title.replace('%{state}', currentState.display_name)}</h1>
        <h4 className="mb-4 font-normal text-xl lg:text-2xl lg:max-w-lg">{subtitle}</h4>
        <AppIcons content={content} color="kale" />
        <StateZipForm
          country={country}
          nearmeFormAction={nearmeFormAction}
          cta="Continue"
          countryPlaceholders={countryPlaceholders}
          className="hidden md:flex"
        />
      </div>
      <img
        src="/landing_page/images/state-jobs-hero-mobile.jpg"
        srcSet="/landing_page/images/state-jobs-hero-mobile.jpg 500w, /landing_page/images/state-jobs-hero.jpg 800w"
        sizes="(max-width: 800px) 300px, 50vw"
        alt={alt}
        className="max-w-lg w-full mt-9 lg:mt-0 rounded-18"
      />
    </div>
  )
}

